import { clientFetch } from '~/api/clientFetch';
import { UserDailyFirstAccessLog } from '../../types/model/userDailyFirstAccessLog';

export type UserDailyFirstAccessLogType = {
  user_daily_first_access_logs: UserDailyFirstAccessLog[];
};

type UserDailyFirstAccessLogSearchParams = {
  page?: string;
};

const endpoint = '/user_daily_first_access_logs';

export async function fetchUserDailyFirstAccessLog(
  signOut: () => void,
  searchParams?: UserDailyFirstAccessLogSearchParams
): Promise<{ data: UserDailyFirstAccessLogType; headers: Record<string, string> }> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await clientFetch(
    endpoint,
    {
      method: 'GET',
      queryString,
    },
    signOut
  );

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function fetchUserDailyFirstAccessLogCSV(
  signOut: () => void
): Promise<{ data: Blob }> {
  const response = await clientFetch(
    `${endpoint}.csv`,
    {
      method: 'GET',
    },
    signOut
  );

  const data = await response.blob();

  return { data };
}
